import axios from "axios";

const API_BASE = "/api/cohort";

const verifyAccess = async () => {
  const response = await axios.get(`${API_BASE}/verify-access`);
  return response.data;
};

const getCurriculum = async () => {
  const response = await axios.get(`${API_BASE}/curriculum`);
  return response.data;
};

const getChallenge = async (challengeId) => {
  const response = await axios.get(`${API_BASE}/challenge/${challengeId}`);
  return response.data;
};

const submitChallenge = async (payload) => {
  const response = await axios.post(`${API_BASE}/submit`, payload);
  return response.data;
};

const markVideoComplete = async (challengeId) => {
  const response = await axios.post(`${API_BASE}/video-complete`, { challengeId });
  return response.data;
};

const submitCohortQuiz = async (payload) => {
  const response = await axios.post(`${API_BASE}/quiz-submit`, payload);
  return response.data;
};

const getLeaderboard = async () => {
  const response = await axios.get(`${API_BASE}/leaderboard`);
  return response.data;
};

const cohortService = {
  verifyAccess,
  getCurriculum,
  getChallenge,
  submitChallenge,
  markVideoComplete,
  submitCohortQuiz,
  getLeaderboard,
};

export default cohortService;
